<!--
 * @Author: Gaho
 * @Date: 2023-12-22 19:11:43
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-30 16:52:52
-->
<template>
    <GameSettingsButtonWrapper
        :tool-tip="$t('Rules')"
        :enable="modelValue"
        @click.self="onClick()"
    >
        <QIcon @click.self="onClick()" name="help" />
    </GameSettingsButtonWrapper>
    <!-- ↑ icon 图标 -->
    <!-- ↓ 弹出窗口 -->
    <RuleSimple
        v-if="oRulsComponent"
        :model-value="modelValue"
        @update:model-value="onModelValue"
    > 
        <component
            :is="oRulsComponent"
        ></component>
    </RuleSimple>
    <ModalRulesRuleSlide
        v-else
        :paylines-pic="aPayLinesPic"
        :carousels="carousels"
        :model-value="modelValue"
        :game-name="name"
        @update:model-value="onModelValue"
    />
</template>

<script setup lang="ts">
import type { CarouselsArray, } from '@/components/Modal/Rules/RuleSlide.vue';
// @ts-ignore
import RuleSimple from '@/components/Modal/Rules/RuleSimple.vue';
// @ts-ignore
import redPacketGame from '@/components/Modal/Rules/Special/redPacketMinesGameRule.vue'; 
// @ts-ignore
import goldenFlowerGame from '@/components/Modal/Rules/Special/goldenFlowerGameRule.vue'; 
// @ts-ignore
import jisuzhajinhuaGame from '@/components/Modal/Rules/Special/jisuzhajinhuaGameRule.vue'; 
// @ts-ignore
import niuNiuGame from '@/components/Modal/Rules/Special/niuNiuGameRule.vue'
// --- ↑ 组件 ------------------

import { spaceDiceRules } from '@/pages/casino/spacediceGame/js/spaceDiceRule.js';
import { rulesData } from '~/pages/casino/plinkoGame/data/oddsData';
import { limboRulesData } from '@/pages/casino/limboGame/data';
import { aHiloRule } from '@/pages/casino/hiloGame/js/HiloRule.js';
import { aKenoRule } from '@/pages/casino/kenoGame/js/kenoRule.js';
import { aCrashRule } from '@/pages/casino/crashGame/js/crashRule.js';
import { aRouletteRule } from '@/pages/casino/rouletteGame/js/rouletteRule.js';
import { aMinesRule } from '@/pages/casino/minesGame/js/mines-rule.js';
import { ruleData } from '@/pages/casino/coinflipGame/data/index';
import { ringRulesData } from '@/pages/casino/ringGame/data/index';
import { cryptosRulesData } from '~/pages/casino/cryptosGame/datas';
import { towerRulesData } from '~/pages/casino/towerGame/data';
import { stairsRulesData } from '@/pages/casino/stairsGame/data';
import { circleRulesData } from '@/pages/casino/circleGame/data';
import { tripleRuleData } from '@/pages/casino/tripleGame/data';
import { aPharaohRule01, aPharaohRule02 } from '@/pages/casino/corgipharaohGame/js/pharaohRule.js';
import { aBlackJackRule } from '@/pages/casino/blackjackGame/ts/blackjackRule'; 


// ↓所有游戏名 
type nameType = | 'spaceDice' | 'dice' | 'plinko' | 'crash' 
    | 'limbo' | 'keno' | 'hilo' | 'coinflip' | 'ring' | 'roulette'
    | 'cryptos' | 'tower' | 'blackjack' | 'stairs' | 'triple'
    | 'circle' | 'mines' | 'redpacketGame' | 'goldenFlowerGame' | 'jisuzhajinhuaGame' | 'niuNiuGame'
    // ---- ↓ corgi 系列 -----------------------
    | 'corgiwild' | 'corgiwaves' | 'corgipharaoh';

const props = defineProps({
    modelValue: { // 值为 true 则打开窗口 
        type: Boolean,
        default: false,
    },
    name: {
        type: String as PropType<nameType>,
        default: '',
    },
});

const emit = defineEmits(['update:modelValue']);

interface AllRuleObj {
    [key: string]: CarouselsArray;
}

// 👇 看这里：
// 游戏名与游戏规则对照表
const aAllRules: AllRuleObj = {
    spaceDice: (spaceDiceRules as unknown) as CarouselsArray,
    plinko: (rulesData as unknown) as CarouselsArray,
    crash: (aCrashRule as unknown) as CarouselsArray,
    limbo: (limboRulesData as unknown) as CarouselsArray,
    keno: (aKenoRule as unknown) as CarouselsArray,
    hilo: (aHiloRule as unknown) as CarouselsArray,
    coinflip: (ruleData as unknown) as CarouselsArray,
    ring: (ringRulesData as unknown) as CarouselsArray,
    roulette: (aRouletteRule as unknown) as CarouselsArray,
    cryptos: (cryptosRulesData as unknown) as CarouselsArray,
    tower: (towerRulesData as unknown) as CarouselsArray,
    stairs: (stairsRulesData as unknown) as CarouselsArray,
    mines: (aMinesRule as unknown) as CarouselsArray,
    triple: (tripleRuleData as unknown) as CarouselsArray,
    circle: (circleRulesData as unknown) as CarouselsArray,
    corgipharaoh: (aPharaohRule01 as unknown) as CarouselsArray,
    corgiwild: ([] as unknown) as CarouselsArray,
    blackjack: (aBlackJackRule as unknown) as CarouselsArray,
    corgiwaves: ([] as unknown) as CarouselsArray,
};

// ↓ 交给子组件的图（游戏玩家截图） 
const carousels = computed(()=>{
    const aRuleOfGame = aAllRules[props.name];
    // console.log("规则组件：游戏名称：", props.name);
    // console.log("规则组件：游戏名称：", aRuleOfGame);
    return aRuleOfGame || [];
});


// ↓交给子组件的图 02 （中奖线）
const aPayLinesPic = computed(()=>{
    // ↓ 目前只有这1个游戏 
    if (props.name === 'corgipharaoh'){
        return (aPharaohRule02 as unknown) as CarouselsArray;
    }
    return [];
});

// ↓ 某些特殊游戏的规则组件（用于弹出窗口中内）
const oRulsComponent = computed(()=>{
    const lib = {
        redpacketGame: markRaw(redPacketGame),
        goldenFlowerGame: markRaw(goldenFlowerGame),
        jisuzhajinhuaGame: markRaw(jisuzhajinhuaGame),
        niuNiuGame: markRaw(niuNiuGame),
    }
    // ↓ 返回空正常，说明当前游戏使用通用规则组件  
    return lib[props.name]; 
});


const onClick = () => {
    emit('update:modelValue', !props.modelValue);
};

const onModelValue = (value) => {
    emit('update:modelValue', value);
};
</script>

